
import { APP_INITIALIZER, Inject, Injectable, Injector, DOCUMENT } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BootstrapperBase } from '@trustedshops/tswp-core-common';
import { RouteContentComponent } from './route-content.component';

@Injectable()
export class RouteContentBootstrapper implements BootstrapperBase {
  //#region Ctor
  public constructor(
    private readonly _injector: Injector,
    @Inject(DOCUMENT) private readonly _document: Document) {
  }
  //#endregion

  //#region Public Methods
  public async initialize(): Promise<void> {
    const customElement = createCustomElement(RouteContentComponent, {
      injector: this._injector
    });

    this._document.defaultView.customElements
      .define(
        RouteContentComponent.selector,
        customElement);
  }

  //#endregion
}

export const ChildRouteContentInitializer = [
  RouteContentBootstrapper,
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (initializer: BootstrapperBase) => {
      return () => initializer.initialize();
    },
    deps: [RouteContentBootstrapper]
  }];
